export const CHILE_TZ = 'America/Santiago';

const partsInChile = (date) => {
  const p = Object.fromEntries(
    new Intl.DateTimeFormat('en-US', {
      timeZone: CHILE_TZ, hourCycle: 'h23',
      year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit',
    }).formatToParts(date).map(x => [x.type, x.value])
  );
  return { y: +p.year, mo: +p.month, d: +p.day, h: +p.hour % 24, mi: +p.minute, s: +p.second };
};

const pad = (n) => String(n).padStart(2, '0');

// ISO (UTC) -> "YYYY-MM-DDTHH:mm" in Chile wall-clock, for <input type="datetime-local">
export const toChileInput = (iso) => {
  if (!iso) return '';
  const p = partsInChile(new Date(iso));
  return `${p.y}-${pad(p.mo)}-${pad(p.d)}T${pad(p.h)}:${pad(p.mi)}`;
};

// "YYYY-MM-DDTHH:mm" interpreted as Chile wall-clock -> ISO UTC string
export const fromChileInput = (value) => {
  if (!value) return undefined;
  const [datePart, timePart = '00:00'] = value.split('T');
  const [y, mo, d] = datePart.split('-').map(Number);
  const [h, mi] = timePart.split(':').map(Number);
  const target = Date.UTC(y, mo - 1, d, h, mi);
  let guess = target;
  for (let i = 0; i < 2; i++) {
    const p = partsInChile(new Date(guess));
    guess += target - Date.UTC(p.y, p.mo - 1, p.d, p.h, p.mi);
  }
  return new Date(guess).toISOString();
};

// Date whose local fields equal Chile wall-clock; use only for display/formatting (date-fns etc).
export const toChileDate = (iso) => {
  const p = partsInChile(iso instanceof Date ? iso : new Date(iso));
  return new Date(p.y, p.mo - 1, p.d, p.h, p.mi, p.s);
};
